import { render, staticRenderFns } from "./infoSlider_v2.vue?vue&type=template&id=136b789f&scoped=true&"
import script from "./infoSlider_v2.vue?vue&type=script&lang=js&"
export * from "./infoSlider_v2.vue?vue&type=script&lang=js&"
import style0 from "./infoSlider_v2.vue?vue&type=style&index=0&id=136b789f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b789f",
  null
  
)

export default component.exports